import React from 'react';
import { useSettingsStore } from '../store';

// Кнопки «Перейти на сайт» здесь нет намеренно: на время техработ сайт лежит
// вместе с mini app, уводить туда пользователя некуда.
const DEFAULT_MESSAGE = 'Временно недоступен, проводим технические работы.';

export const MaintenanceScreen: React.FC = () => {
  const { settings } = useSettingsStore();
  const message = settings.maintenance?.message?.trim() || DEFAULT_MESSAGE;

  return (
    <div
      className="fixed inset-0 z-[300] flex flex-col items-center justify-center px-6"
      style={{ background: '#F2F2F7' }}
    >
      <div className="flex flex-col items-center w-full max-w-sm">
        <img
          src="/maintenance.png"
          alt=""
          className="w-full max-w-[420px] object-contain -mb-2"
          style={{ maxHeight: '45vh' }}
        />
        <p className="text-2xl font-bold text-text-primary mb-3 text-center" style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '-0.3px' }}>
          Технические работы
        </p>
        <p className="text-[15px] text-text-secondary leading-relaxed text-center">
          {message}
        </p>
      </div>
    </div>
  );
};
